import {REHYDRATE} from 'redux-persist';

const initialState = {
  tableauToken: null,
  fetchingTableauToken: false,
  selectedReportUrl: null,
  selectedReportTitle: null,
  tableauTokenForSelectedReport: null,
  reportModalVisible: false,
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.reports,
          tableauToken: null,
          fetchingTableauToken: false,
          selectedReportUrl: null,
          selectedReportTitle: null,
          tableauTokenForSelectedReport: null,
          reportModalVisible: false,
        };
      }
      return state;

    case 'FETCH_TABLEAU_TOKEN_STARTED':
      return {
        ...state,
        fetchingTableauToken: true,
      };

    case 'FETCHED_TABLEAU_TOKEN':
      return {
        ...state,
        tableauToken: action.token,
        fetchingTableauToken: false,
      };

    case 'FETCH_TABLEAU_TOKEN_FAILED':
      return {
        ...state,
        fetchingTableauToken: false,
      };

    case 'USER_SELECTED_REPORT':
      return {
        ...state,
        selectedReportUrl: action.reportUrl,
        selectedReportTitle: action.reportTitle,
        tableauTokenForSelectedReport: null,
      };

    case 'FETCHED_TABLEAU_FOR_SELECTED_REPORT_TOKEN':
      return {
        ...state,
        tableauTokenForSelectedReport: action.token,
      };

    case 'SHOW_REPORT_MODAL':
      return {
        ...state,
        reportModalVisible: true,
      };

    case 'HIDE_REPORT_MODAL':
      return {
        ...state,
        reportModalVisible: false,
      };

    case 'CLEAR_TABLEAU_TOKEN':
      return {
        ...state,
        tableauToken: null,
      };

    case 'CLEAR_TABLEAU_TOKEN_FOR_SELECTED_REPORT':
      return {
        ...state,
        tableauTokenForSelectedReport: null,
      };

    default:
      return state;
  }
}
